import get from 'get-value';
import {marketingWebsocketCommands} from '../../constants/marketingWebsocketCommands';

export const marketingExportTickets = (state = {
    isLoadingExport: false,
    exportRecord: {},
    correlationId: null,
}, action) => {
    switch (action.type) {
        case marketingWebsocketCommands.MARKETING_EXPORT_GET: {
            return Object.assign({}, state, {isLoadingExport: true});
        }
        case marketingWebsocketCommands.MARKETING_EXPORT_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            const exportRecord = get(action, 'payload.exportRecord', {default: {}});
            return Object.assign({}, state, {
                isLoadingExport: false,
                exportRecord,
                correlationId,
            });
        }
        case marketingWebsocketCommands.MARKETING_EXPORT_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {isLoadingExport: false});
        }
        case marketingWebsocketCommands.MARKETING_EXPORT_CREATE: {
            const exportRecord = {
                created: new Date(),
                status: 'NEW'
            };
            return Object.assign({}, state, {exportRecord});
        }
        case marketingWebsocketCommands.MARKETING_EXPORT_STATUS:
        case marketingWebsocketCommands.MARKETING_EXPORT_ERROR: {
            const {correlationId, exportRecord} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {exportRecord, correlationId});
        }
        default:
            return state;
    }
};
